var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrowdstrikeBird(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "58px",
    viewBox: "0 0 76.0 58.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,1080 L0,1080 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C3.44375,2.196138 7.62216667,5.69203113 14.4178333,4.88528656 C21.1675833,4.03372285 25.7133333,2.509872 34.4375,8.87419027 C32.8304167,8.73973284 29.9835833,8.33636055 26.4020833,10.0843071 C22.8205833,11.8322537 21.4430833,11.921892 19.6523333,11.7426154 C20.1574167,12.6838174 21.2135,13.9387534 24.5195,14.1628491 C27.8255,14.3869448 29.3866667,14.4765831 27.6418333,18.4654868 C27.68775,17.25537 27.41225,14.9247745 24.1521667,15.3281468 C20.8920833,15.7315191 20.1115,18.5999442 23.6470833,20.0341568 C22.4991667,20.2582525 20.1115,20.39271 18.3666667,16.000434 C17.1728333,16.4934445 15.3361667,17.5242848 11.98425,15.0144128 C13.1321667,15.4177851 14.6015,15.4626043 14.6015,15.4626043 C11.6169167,14.0732108 8.816,11.5185197 6.97933333,9.09828598 C8.40275,10.1291263 10.0098333,11.2047857 11.6169167,11.3840623 C9.73433333,9.14310512 5.32633333,4.61637171 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C2.50285128,1.96987725 7.69057938,5.86158596 12.9693203,5.42917388 C12.1502053,4.17998343 10.6940009,3.2190677 8.91925182,2.25815197 C10.9215328,2.73860984 16.9738823,4.37216658 24.9375,13.0204082 C20.705406,11.0985767 19.7952783,10.7142104 14.3800182,9.22479102 C8.91925182,7.78341743 3.59500456,4.70848708 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C9.05969101,9.6356135 15.877809,13.4259259 20.5477528,16.4399093 C30.1211376,22.4222096 32.1292135,26.4408541 33.25,29.5918367 C28.6734551,23.2442051 22.5558287,21.2805493 17.8391854,18.1295666 C4.88988311,10.2101265 1.3127353,3.92992525 0.25989975,0.870516126 L0.18889783,0.657485788 C0.110855147,0.415390663 0.0492101607,0.19592365 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C6.55628765,6.84204318 13.8100527,10.4455192 18.0879142,12.7718139 C27.3411145,17.6068578 29.7125377,21.0278794 30.875,23.6734694 C26.4576431,18.427903 20.3198419,16.6033581 16.6929593,14.687586 C3.62688253,7.89115646 0.604480422,2.46313554 0,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 C5.56066639,6.66601067 12.7568229,13.0580757 30.8406708,18.1260701 C51.6908333,23.7967449 51.9350167,27.1100992 50.5671084,30.6615043 L50.4758066,30.8934818 C50.3826095,31.1258502 50.2843118,31.359471 50.1861824,31.5950643 C48.9712469,34.4258359 50.3730956,34.7454392 50.933835,34.9737272 C53.830989,36.0238522 61.4477001,37.439238 60.9804172,40.5896129 C61.0010646,40.6097872 61.0230261,40.631369 61.0462119,40.6543124 L61.1992979,40.8079439 C62.3082183,41.936179 65.0881598,45.0959126 63.7841145,47.3469388 C62.6159073,45.4749769 57.1486975,40.5439553 50.5600087,39.5394879 C43.97132,38.5350206 37.9433707,40.7265857 32.9901721,37.4848956 C28.7378978,34.5171511 28.0837017,33.4213685 23.8314274,26.6183851 C23.4056808,25.938594 23.0583915,25.2723312 22.7044359,24.5905359 L22.5265085,24.2482094 C21.3313678,21.9556097 19.9045204,19.4366125 15.0932374,15.6149017 C8.59800518,10.4555921 2.52332761,7.67047803 0,0 Z M56.9617843,38.8546238 C56.9617843,38.8546238 58.7841876,39.7221184 60.2327646,41.274477 C60.2327646,41.2119982 60.2331529,41.1507841 60.2333913,41.0908015 L60.2331188,40.9145148 C60.222927,39.9361147 60.0138794,39.3039908 56.9617843,38.8546238 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-84.0 -351.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.0 351.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.99999999999996 37.87755102040816)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 34.4375,0 34.4375,20.122449 0,20.122449 0,0",
    stroke: "none",
    fill: "#54BAAF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.81249999999998 33.14285714285715)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 24.9375,0 24.9375,13.0204082 0,13.0204082 0,0",
    stroke: "none",
    fill: "#54BAAF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 33.25,0 33.25,29.5918367 0,29.5918367 0,0",
    stroke: "none",
    fill: "#54BAAF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.562499999999968 10.65306122448978)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i4)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 30.875,0 30.875,23.6734694 0,23.6734694 0,0",
    stroke: "none",
    fill: "#54BAAF"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.874999999999979 2.3673469387755155)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i5)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 64.125,0 64.125,47.3469388 0,47.3469388 0,0",
    stroke: "none",
    fill: "#54BAAF"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrowdstrikeBird);
export default __webpack_public_path__ + "static/media/crowdstrike-bird.ea72d8342a5b42e2729c4e42ec01569c.svg";
export { ForwardRef as ReactComponent };